document.addEventListener('readystatechange', function() {
    setTimeout(changeScrollArrowVisibility, 2 * 1000);
})

const scrollArrowMobile = document.getElementById('scrollArrowMobile');
const scrollArrowDesktop = document.getElementById('scrollArrowDesktop');

if(scrollArrowMobile && scrollArrowDesktop) {
    document.addEventListener('scroll', function() {
        let scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

        // adding window.screen.height since scrollTop tracks distance from the top of the screen
        // adding 50px offset, looks smoother
        if(scrollTop + window.screen.height + 50 > document.body.offsetHeight) {
            scrollArrowMobile.classList.remove('show');
            scrollArrowDesktop.classList.remove('show');
        }
        else {
            scrollArrowMobile.classList.add('show');
            scrollArrowDesktop.classList.add('show');
        }
    })
}

function changeScrollArrowVisibility() {
    // adding 20px offset. In case the page is just a bit longer because of some padding/margin
    if(document.body.offsetHeight > window.screen.height && scrollArrowMobile && scrollArrowDesktop) {
        scrollArrowMobile.classList.add('show');
        scrollArrowDesktop.classList.add('show');
    }
}